var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1673 10.416V5.66602C17.1673 4.26588 17.1673 3.56582 16.8948 3.03104C16.6552 2.56063 16.2727 2.17818 15.8023 1.9385C15.2675 1.66602 14.5674 1.66602 13.1673 1.66602H7.83398C6.43385 1.66602 5.73379 1.66602 5.19901 1.9385C4.7286 2.17818 4.34615 2.56063 4.10647 3.03104C3.83398 3.56582 3.83398 4.26588 3.83398 5.66602V14.3327C3.83398 15.7328 3.83398 16.4329 4.10647 16.9677C4.34615 17.4381 4.7286 17.8205 5.19901 18.0602C5.73379 18.3327 6.43385 18.3327 7.83398 18.3327H10.5007M12.1673 9.16602H7.16732M8.83398 12.4993H7.16732M13.834 5.83268H7.16732M12.584 15.8327L14.2507 17.4993L18.0007 13.7493",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskTimeline);
export default __webpack_public_path__ + "static/media/task-timeline.b0003e04c0f3e34bea98017a94c8cba0.svg";
export { ForwardRef as ReactComponent };